import { InjectionToken } from '@angular/core';

export const HTTP_OBSERVER_OPTIONS = new InjectionToken('HTTP_OBSERVER_OPTIONS');